import axios from 'axios';
import Constants from '../constants';
import { IExternalApplicationType } from '../models';

export async function getExternalApplicationTypes(externalClientId: string): Promise<IExternalApplicationType[]> {
	const url = Constants.API_CLIENT_EXTERNAL_APPLICATION_TYPES_URL.replace('{clientId}', externalClientId.toString());
	try {
		const result = await axios.get(url, { headers: { Pragma: 'no-cache' } });
		if (result.status === 200) {
			return result.data;
		}
	} catch {
		/*generic error*/
	}
	throw new Error(Constants.API_EXTERNAL_APPLICATION_TYPES_ERROR);
}

export async function getMinN(clientId: number): Promise<any> {
	const url = Constants.API_CLIENT_MIN_N_URL.replace('{clientId}', clientId.toString());
	const result = await axios.get(url, { headers: { Pragma: 'no-cache' } });
	return result.data;
}
